import Confirm from '@/components/common/Confirm.vue';
import Balance from '@/utils/balance';
import * as types from '@/store/mutation-types';
import {
    mapState,
} from 'vuex';
import Config from '../../utils/Config';

export default {
    name: 'Transfer',
    props: ['currTarget', 'balance', 'availableBtt'],
    components: {
        Confirm,
    },
    data() {
        return {
            confirmStatus: false,
            currAccountIndex: -1,
            transfer: {
                curr: {
                    address: '',
                    amount: '',
                    msg: '',
                },
            },
        };
    },
    computed: {
        ...mapState({
            storeConfirmStatus: state => state.confirmStatus,
            user: state => state.user,
        }),
    },
    mounted() {},
    methods: {
        showDialog() {
            const self = this;
            if (
                self.transfer.curr === '' ||
                self.transfer.curr.amount === '' ||
                self.transfer.curr.amount === 0
            ) {
                self.$Message.error(self.$t('balance_please_input_address_and_amount'));
            }
            if (
                parseFloat(self.transfer.curr.amount) >
                parseFloat(self.currTarget.available)
            ) {
                return self.$Message.error(self.$t('trade_balance_not_enough'));
            }

            self.confirmStatus = true;
            self.currAccountIndex = self.$store.state.currAccountIndex;
            if (Config.CenterTrade) {
                self.confirmTransferAction({ code: 0 });
            } else {
                self.$store.commit(types.CHANGE_CONFIRMSTATUS, true);
            }
        },
        confirmTransferAction(res) {
            const self = this;
            if (res.code === 0) {
                self.doTransfer(res.password);
                self.confirmStatus = false;
            }
        },
        close() {
            this.$emit('withdrawhidden');
            this.$store.commit(types.CHANGE_CONFIRMSTATUS, false);
        },
        doTransfer(pwd) {
            const self = this;
            let accountInfo;
            const currTarget = self.currTarget;
            const password = pwd;
            const targetAddress = self.transfer.curr.address;
            const amt = self.transfer.curr.amount;
            const avabtt = self.availableBtt;
            const msg = self.transfer.curr.msg;
            if (Config.CenterTrade) {
                accountInfo = {
                    userid: self.user.bttUserid,
                };
            } else {
                accountInfo = self.$store.getters.currAccount;
            }
            Balance.transferAction(
                accountInfo,
                currTarget,
                password,
                targetAddress,
                amt,
                avabtt,
                msg,
            ).then((res) => {
                if (res.code === 0) {
                    self.$Message.success(self.$t('balance_successful_transfer'));
                    self.$emit('withdrawhidden');
                    self.$store.commit(types.CHANGE_CONFIRMSTATUS, false);
                }
            })
                .catch((e) => {
                    self.$store.commit(types.CHANGE_CONFIRMSTATUS, false);
                    self.$Message.error(self.$t(e));
                });
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/common/transfer.js